// src/config.js

// Domain'e göre otomatik tespit
const hostname = window.location.hostname;

// API ve Frontend URL'leri
let API_BASE_URL, FRONTEND_BASE, APP_NAME;

if (hostname.includes('tgsosmdya')) {
  API_BASE_URL = 'https://api.tgsosmdya.com';
  FRONTEND_BASE = 'https://tgsosmdya.com';
  APP_NAME = 'TG Sosmedya';
} else {
  API_BASE_URL = 'https://api.autogram.site';
  FRONTEND_BASE = 'https://autogram.site';
  APP_NAME = 'Autogram';
}

export const MAIL_API_URL = process.env.REACT_APP_MAIL_API_URL || 'https://mail.kralsosyal.com';
export const MAIL_API_KEY = process.env.REACT_APP_MAIL_API_KEY || '';

export const API_URL = `${API_BASE_URL}/api`;
export const AUTH_URL = `${API_BASE_URL}/api/auth`;
export const API_BASE_URL_EXPORT = API_BASE_URL;
export const BASE_URL = FRONTEND_BASE;
export const SOCKET_URL = API_BASE_URL;
export const FRONTEND_URL = FRONTEND_BASE;
export { APP_NAME };

export default API_URL;